import { useState, useEffect } from 'react';

/**
 * Returns a debounced version of the value that only updates
 * after the specified delay has elapsed without changes.
 *
 * @param {*} value
 * @param {number} delay - milliseconds
 * @returns {*} debounced value
 *
 * @example
 * const debouncedSearch = useDebounce(searchTerm, 300);
 */
const useDebounce = (value, delay = 300) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debouncedValue;
};

export default useDebounce;
